import metadata from '../package.json';
export const CURRENT_APP_VERSION_NAME = metadata.version;
export const CURRENT_APP_VERSION_CODE = 0;
export const PRODUCTION_HOST = 'http://123.56.219.115:8000';
export const APP_UPDATE_MANIFEST_URL = `${window.location.origin}/static/app-update/android.json`;
export interface CurrentAppVersion { versionName: string; versionCode: number; source: 'native' | 'fallback'; }
export async function getCurrentAppVersion(): Promise<CurrentAppVersion> {
  return { versionName: CURRENT_APP_VERSION_NAME, versionCode: 0, source: 'fallback' };
}
